<template>
    <div class="form-group formly-input"
         :class="[ to.inputType, to.wrapperClasses, {'formly-has-value': model[field.key], 'formly-has-focus': form[field.key].$active, 'has-error has-danger': hasError}]">
        <label v-if="to.label" :for="to.id ? to.id : null">{{to.label}}</label>
        <vue-chosen :multiple="true" v-model="value" :options="field.options"></vue-chosen>
        <error-display :form="form" :field="field.key"></error-display>
    </div>
</template>

<script>
    import baseField from 'vue-formly-bootstrap/src/fields/baseField'
    import VueChosen from '@/components/VueChosen'

    export default {
        mixins: [baseField],
        props: ['form', 'field', 'model', 'to'],
        name: 'multiSelect',
        components: {VueChosen},
        data () {
            return {}
        },
        computed: {
            value: {
                get () {
                    return this.model[this.field.key]
                },
                set (newValue) {
                    this.model[this.field.key] = newValue || []
                }
            }
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// MultiSelect.vue?3dfe0e50